import { PureComponent, ReactNode } from 'react';
import Hotkeys from 'react-hot-keys';
import { AnimatePresence, motion } from 'framer-motion';

type Props = {
    closeMe: () => void;
    children: JSX.Element;
    contentCssClasses?: string;
    zIndex?: number;
};

class Modal extends PureComponent<Props> {
    render(): ReactNode {
        const { closeMe, children, contentCssClasses } = this.props;

        return (
            <AnimatePresence>
                <motion.div
                    initial={{ opacity: 0 }}
                    exit={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    style={{ zIndex: this.props.zIndex ?? 20 }}
                    transition={{ duration: 0.2, ease: 'linear' }}
                    className="flex absolute inset-0"
                >
                    <div onClick={closeMe} className="modal-overlay" />
                    <div className={`w-33p ${contentCssClasses} bg-white modal-content`}>
                        {children}
                    </div>
                </motion.div>
            </AnimatePresence>
        );
    }
}

export default Modal;
